<template>
  <v-select
    label="Tipo de Comprobante*"
    v-model="iModel"
    :items="items"
    item-value="Id_TipoComprobante"
    item-text="Nombre"
    :rules="rules"
    :readonly="readonly"
    :loading="loading"
  >
    <template v-slot:no-data
      >No hay datos para mostrar</template
    >
    <template v-slot:progress>
      <v-progress-circular color="blue" indeterminate></v-progress-circular>
    </template>
  </v-select>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
export default {
  name: "SelectTipoComprobante",
  props: {
    id_Modulo: Number,
    model: Number,
    rules: {},
    readonly: Boolean
  },
  data() {
    return {
      items: [],
      loading: false
    };
  },
  watch: {
    id_Modulo: function(valor) {
      this.listarItems(valor);
    }
  },
  computed: {
    iModel: {
      get() {
        return this.model;
      },
      set(valor) {
        if (valor != undefined && valor != 0) {
          var ind = this.items.findIndex(x => x.Id_TipoComprobante == valor);
          this.$emit("seleccionarItem", this.items[ind]);
        }
      }
    }
  },
  methods: {
    listarItems(id) {
      this.items = [];
      if (id != undefined && id > 0) {
        this.loading = true;
        HttpHelper.get("TipoComprobante/ListarPorModulo", {
          id: id
        })
          .then(response => {
            this.items = response.data;
            if (this.items.length > 0)
              this.iModel = this.items[0].Id_TipoComprobante;
            this.loading = false;
          })
          .catch(error => {
            return Promise.reject(error);
          });
      }
    }
  }
};
</script>
